export default __webpack_public_path__ + "static/media/login-page-keys.284ca7dd.png";